import Main from './main.layout';

export default {
    Main
}